import { OrgSelector } from '~/components/Layout/OrgSelector'
import { PageLayout } from '~/components/component-library'
import { Breadcrumb } from '~/components/create-team/Breadcrumb'
import { TeamStep } from '~/components/create-team/steps/1_TeamStep'
import { ProfileStep } from '~/components/create-team/steps/2_ProfileStep'
import { OwnersStep } from '~/components/create-team/steps/3_OwnersStep'
import { TreasuryStep } from '~/components/create-team/steps/4_TreasuryStep'
import { RecoveryStep } from '~/components/create-team/steps/5_RecoveryStep'
import { ReviewStep } from '~/components/create-team/steps/6_ReviewStep'
import { SMART_ACCOUNTS_SETUP_STEPS } from '~/constants/orgs'
import { useSmartAccountSetupStep } from '~/hooks/useSmartAccountSetupStep'

function getStepConfig(step: number): {
  title?: string
  breadcrumbs?: { label: string; index: number }
} {
  return (
    Object.values(SMART_ACCOUNTS_SETUP_STEPS).find(
      ({ breadcrumbs }) => breadcrumbs?.index === step,
    ) ?? {}
  )
}

export const CreateTeamWizard = () => {
  const stepProps = useSmartAccountSetupStep()

  return (
    <>
      <div className="md:fixed md:left-0 md:top-0 md:z-10 md:p-3">
        <div className="md:w-56 md:rounded-lg md:bg-white md:ring-1 md:ring-inset md:ring-gray-200 dark:md:bg-gray-900 dark:md:ring-gray-700">
          <OrgSelector />
        </div>
      </div>
      <PageLayout>
        <div className="flex w-full items-center justify-between space-x-2">
          <div className="flex flex-wrap items-center -space-x-2">
            {Object.values(SMART_ACCOUNTS_SETUP_STEPS)
              .filter(({ breadcrumbs }) => breadcrumbs?.label)
              .map(({ breadcrumbs }, index) => (
                <Breadcrumb
                  key={index}
                  index={index}
                  label={breadcrumbs?.label ?? ''}
                  {...stepProps}
                />
              ))}
          </div>
        </div>
        <div className="mt-1 flex w-full flex-col space-y-2">
          <h1 className="text-2xl font-semibold">
            {stepProps.step === 5
              ? 'Review'
              : getStepConfig(stepProps.step).title}
          </h1>
        </div>
        <div className="w-full space-y-6">
          {stepProps.step === 0 && <TeamStep {...stepProps} />}
          {stepProps.step === 1 && <ProfileStep {...stepProps} />}
          {stepProps.step === 2 && <OwnersStep {...stepProps} />}
          {stepProps.step === 3 && <TreasuryStep {...stepProps} />}
          {stepProps.step === 4 && <RecoveryStep {...stepProps} />}
          {stepProps.step === 5 && <ReviewStep {...stepProps} />}
        </div>
      </PageLayout>
    </>
  )
}
